import React, { useEffect } from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';
import { Controller, UseFormReturn } from 'react-hook-form';

import { DateRangeFilter } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter';
import {
    TabOptions,
    TodayMenuOptions,
    VersionDateMenuOptions,
} from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';
import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: { value?: string[] | string; type?: TabOptions };
    isSelected?: boolean;
}

type InputValueData = {
    type: string | undefined;
    value: string | string[] | undefined;
};

const getInputValue = (data: InputValueData) => {
    if (!data?.value) return '';
    if (data.type === 'FIXED_DATE' && data.value) {
        return `${moment(Number(data.value[0])).format(constants.formats.date.default)} - ${moment(
            Number(data.value[1]),
        ).format(constants.formats.date.default)}`;
    }

    switch (data.type) {
        case 'TODAY_REF':
            return TodayMenuOptions.find((item) => item.value === data.value)?.inputLabel || '';
        case 'VERSION_DATE_REF':
            return VersionDateMenuOptions.find((item) => item.value === data.value)?.inputLabel || '';
        default:
            return '';
    }
};

export const BaselineStartDateFilter = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const handleBaselineStartDateSelection = (data: { value?: string[] | string; type?: TabOptions }) => {
        methods?.setValue(name, data);
        handleFilters?.();
    };

    return isSelected ? (
        <div className={classes.selectWrapper}>
            <Controller
                render={() => (
                    <DateRangeFilter
                        onChange={handleBaselineStartDateSelection}
                        value={value ?? {}}
                        inputDefaultValue={getInputValue(value as InputValueData)}
                        label={FilterLabels.BASELINE_START_DATE_CARD_BOARD}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
